// extracted by mini-css-extract-plugin
module.exports = {"compass":"Compass_compass__2wd8v","icon":"Compass_icon__3hlK8","bubble":"Compass_bubble__C7LTe","hidden":"Compass_hidden__3SKz_ Compass_compass__2wd8v"};